/**
 * Ensure print output is ALWAYS in light mode + handle landscape opt-in.
 * Strip the `dark` class on <html> before the print dialog opens and restore
 * it afterwards. Also toggles a `print-landscape` body class when the active
 * `[data-print-root]` opts into landscape via `data-print-landscape="true"`.
 */
let wasDark = false;

if (typeof window !== "undefined") {
  window.addEventListener("beforeprint", () => {
    wasDark = document.documentElement.classList.contains("dark");
    if (wasDark) document.documentElement.classList.remove("dark");
    const root = document.querySelector("[data-print-root]") as HTMLElement | null;
    if (root && root.dataset.printLandscape === "true") {
      document.body.classList.add("print-landscape");
    } else {
      document.body.classList.remove("print-landscape");
    }
  });
  window.addEventListener("afterprint", () => {
    if (wasDark) document.documentElement.classList.add("dark");
    document.body.classList.remove("print-landscape");
  });
}

export {};
